import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import MuiPaper from '@material-ui/core/Paper';

const Paper = ({ children, ...otherProps }) => (
  <MuiPaper {...otherProps}>
    { children }
  </MuiPaper>
);

Paper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default React.memo(Paper);



// WEBPACK FOOTER //
// ./components/core/Paper.js